export default __webpack_public_path__ + "4dbaa6a.png";